export const getMatrixItemsByPurchaseType = (consumablesMatrixData, purchaseType) => {
    return consumablesMatrixData.items.filter((item) => item.purchaseType === purchaseType);
};
//# sourceMappingURL=getMatrixItemsByPurchaseType.js.map